import React from "react";
import { COLORS } from "./constants";
import { TrustCard, SourceRow, SourceHeader, Tag } from "./TrustCard";

// Honest citations — the sources list under an answer now shows only the
// sources the answer actually used, not every file it looked at. Before: a
// cluttered list with an unrelated file. After: only the cited sources.
export const Scene8Citations: React.FC = () => {
  const before = (
    <div>
      <SourceHeader text="Sources (4)" color={COLORS.textMuted} />
      <SourceRow icon="📦" name="batch_runner.py" c={COLORS.neonPurple} mode="plain" />
      <SourceRow icon="📦" name="redis_shards.py" c={COLORS.neonPurple} mode="plain" />
      <SourceRow icon="💬" name="#architecture · Jan-14" c={COLORS.neonPink} mode="plain" />
      <SourceRow icon="📄" name="onboarding_checklist.md" c={COLORS.neonYellow} mode="flagged" />
    </div>
  );

  const after = (
    <div>
      <SourceHeader text="Sources (3)" color={COLORS.neonGreen} />
      <SourceRow icon="📦" name="batch_runner.py" c={COLORS.neonPurple} mode="cited" />
      <SourceRow icon="📦" name="redis_shards.py" c={COLORS.neonPurple} mode="cited" />
      <SourceRow icon="💬" name="#architecture · Jan-14" c={COLORS.neonPink} mode="cited" />
      <div style={{ marginTop: 18 }}>
        <Tag color={COLORS.neonGreen} text="Only what the answer actually used" />
      </div>
    </div>
  );

  return (
    <TrustCard
      accent={COLORS.neonBlue}
      index="2 / 4"
      title="Honest citations"
      subtitle="The sources list shows only what the answer used — not every file it looked at."
      before={before}
      after={after}
    />
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
